<template>
    <div id="app">
        <a-config-provider :locale="locale">
            <keep-alive :include="aliveRoutes">
                <router-view />
            </keep-alive>
        </a-config-provider>
    </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import axios from 'axios';
import storage from 'store';
import { mapState } from 'vuex';
import updateTheme from '../config/theme.change';
import { getHashParams } from '@/utils/common';
export default {
    data() {
        return {
            locale: zhCN,
            aliveRoutes: []
        };
    },
    watch: {
        $route: {
            handler() {
                let lang = this.$route.params.lang || 'cn';
                // 设置语言
                this.$i18n.locale = lang;
                // 设置antdesign语言包
                if (lang == 'cn') {
                    this.locale = zhCN;
                }
                if (lang == 'en') {
                    this.locale = enUS;
                }
                // 如果非等于本地则处理发包缓存问题
                if (process.env.NODE_ENV !== 'development') {
                    // 处理发包缓存问题
                    this.contractCache();
                }
            },
            immediate: true
        }
    },
    components: {},
    computed: {},
    methods: {
        //处理发包缓存问题
        contractCache() {
            axios
                .get(window.location.origin + `/config.json`, {
                    params: {
                        _t: new Date().getTime()
                    }
                })
                .then(res => {
                    const VUE_APP_VERSION = res.version;
                    const vers = storage.get('Version');
                    if (vers) {
                        if (VUE_APP_VERSION != vers) {
                            // 检测到已更新
                            this.$message.warning(this.$t('web.new_version_detected' /* 已检测到系统已更新，2s后自动为您切换到最新版本 */));
                            setTimeout(() => {
                                //alert(this.$t(`omission.newVersionDetectedPleaseRefresh`));
                                // 更新版本号并刷新页面
                                storage.set('Version', VUE_APP_VERSION);
                                location.reload(true);
                            }, 2000);
                        }
                    } else {
                        storage.set('Version', VUE_APP_VERSION);
                    }
                });
        }
    },
    mounted() {},
    created() {
        // 会议主色
        let themeColor = '#398cdd';
        let themeActiveColor = '#1d6ebf';
        let forum_id = getHashParams('forum_id');
        // 论坛主色
        if (forum_id && forum_id !== undefined) {
            themeColor = '#0cb2a8';
            themeActiveColor = '#009189';
        }
        let styleStr = document.getElementsByTagName('html')[0].getAttribute('style');
        document.getElementsByTagName('html')[0].setAttribute('style', '--theme-color:' + themeColor + ';--theme-active-color:' + themeActiveColor + ';' + styleStr);
        updateTheme(themeColor);
    }
};
</script>
<style lang="less">
body {
    font-size: 14px !important;
    word-wrap: break-word;
}
#app {
    //font-family: Avenir, Helvetica, Arial, sans-serif;
    // font-family: PingFang SC,Arial,Microsoft YaHei,sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #303133;
    word-break: normal;
    overflow-wrap: break-word;
    section.ant-layout {
        overflow-x: hidden;
    }
}
// .ant-table,.table-page-search-wrapper{
//     min-width:1000px;
// }
.ant-spin {
    width: 100%;
    padding: 100px 0 !important;
}
body .ant-modal-header,
body .ant-drawer-header {
    background-color: #f9f9f9;
}

@media screen and (max-width: 768px) {
    .ant-drawer-content-wrapper {
        width: 100% !important;
    }
}
</style>
